import { h, Component } from 'preact';
import style from './style.less';
import HorizontalCard from '../../cards/horizontal-card';
// import SimpleGridCluster from '../simple-grid-cluster';
import CardHeader from '../../pieces/card-header';
import { fetchArticleList } from '../../../lib/data';
import { fetchFromDailyMotionPlaylist } from '../../../lib/dailymotion';

import { TrackingProvider, DIMENSION } from '@cube/track';
import SimpleVerticalCard from '../../cards/simple-vertical-card';
import cx from 'classnames';
import LinksClusterP25 from '../links-cluster-p25';
import { getCommonProps } from '../../../lib/page';

/**
 * The main cluster used to display a category of information
 * Layout:
 * - one full width card with 50% image
 * - 1xN simple vertical cards
 * - X number of full width horizontal cards
 * @param {string} theme					light or dark
 * @param {string} title					text to display at top of cluster
 * @param {object} link						text and location of link to put in header of cluster
 * @param {string} topCardClass				fully resolved or local class to apply to top card
 * @param {integer} middleCardCount			how many cards to display in middle section
 * @param {Integer} verticalCardCount		number of cards to display in bottom section
 * @param {string} taboolaNewsroomTag		taboola newsroom tag to apply to cluster
 */
const HERO_BREAKPOINT = 1160;
export default class CategoryClusterP25 extends Component {
	state = {
		topAsset: null,
		middleAssets: [],
		bottomAssets: [],
		hasResults: false
	};

	getAssets = (props) => {
		let vamCount = 0,
			dmCount = 0;

		if (props.dmPlaylist && props.dmLocation) {
			if (props.dmLocation.zone1) dmCount++;
			else vamCount++;
			if (props.dmLocation.zone2) dmCount += props.middleCardCount;
			else vamCount += props.middleCardCount;
			if (props.dmLocation.zone3) dmCount += props.verticalCardCount;
			else vamCount += props.verticalCardCount;

			fetchFromDailyMotionPlaylist({ limit: dmCount, ...props }).then((res) => {
				if (res.articles && res.articles.length > 0) {
					let newState = { hasResults: true };

					if (props.dmLocation.zone1) {
						newState.topAsset = res.articles[0];
					}
					if (props.dmLocation.zone2) {
						let start = props.dmLocation.zone1 ? 1 : 0;
						newState.middleAssets = res.articles.slice(
							start,
							start + props.middleCardCount
						);
					}
					if (props.dmLocation.zone3) {
						let start =
							(props.dmLocation.zone1 ? 1 : 0) +
							(props.dmLocation.zone2 ? props.middleCardCount : 0);
						newState.bottomAssets = res.articles.slice(
							start,
							start + props.verticalCardCount
						);
					}

					this.setState(newState);
				}
			});
		}
		else {
			// All filled by VAM
			vamCount = 1 + props.middleCardCount + props.verticalCardCount;
			props.dmLocation = { zone1: false, zone2: false, zone3: false };
		}

		if (vamCount > 0) {
			return fetchArticleList({
				count: vamCount,
				imageSizes: 'w=640,h=360|w=256,h=144|w=84,h=72',
				...props
			}).then((res) => {
				if (res.articles && res.articles.length > 0) {
					let newState = { hasResults: true };

					if (!props.dmLocation.zone1) {
						newState.topAsset = res.articles[0];
					}
					if (!props.dmLocation.zone2) {
						let start = !props.dmLocation.zone1 ? 1 : 0;
						newState.middleAssets = res.articles.slice(
							start,
							start + props.middleCardCount
						);
					}
					if (!props.dmLocation.zone3) {
						let start =
							(!props.dmLocation.zone1 ? 1 : 0) +
							(!props.dmLocation.zone2 ? props.middleCardCount : 0);
						newState.bottomAssets = res.articles.slice(
							start,
							start + props.verticalCardCount
						);
					}

					this.setState(newState);
				}
			});
		}
	};

	static defaultProps = {
		middleCardCount: 2,
		verticalCardCount: 5
	};

	componentWillMount() {
		this.getAssets(this.props);
	}

	render(
		{
			theme,
			title,
			link,
			topCardClass,
			middleCardCount,
			qeId,
			taboolaNewsroomTag,
			width,
			linksfeed,
			...props
		},
		{ topAsset, middleAssets, bottomAssets, hasResults }
	) {
		if (!hasResults) return null;
		return (
			<TrackingProvider
				{...{
					[DIMENSION.componentpath]: title
						? title.replace(/\s/g, '') + 'Cluster'
						: 'CategoryCluster'
				}}
			>
				<div
					{...(taboolaNewsroomTag
						? { 'data-tb-region': taboolaNewsroomTag }
						: {})}
					class={style.categoryCluster}
					qid={qeId}
				>
					<div class={style.cards}>
						<div class={style.topCard}>
							<TrackingProvider
								{...{
									[DIMENSION.componentpath]: 'Top-Hero',
									[DIMENSION.clickindex]: 1
								}}
							>
								{topAsset && (
									<HorizontalCard
										theme={theme}
										asset={topAsset}
										imageRole="w=640,h=360"
										size="large"
										imageProportion="half"
										cardClass={'story-hero'}
										titleLines={3}
										qeId={qeId + '-top-0'}
										showSummary={false}
										{...props}
									/>
								)}
							</TrackingProvider>
							<div class={style.secondaryCards}>
								{middleAssets.length === middleCardCount &&
									middleAssets.map((asset, i) => (
										<TrackingProvider
											{...{
												[DIMENSION.componentpath]: 'Top-Right',
												[DIMENSION.clickindex]: i + 1
											}}
										>
											<HorizontalCard
												theme={theme}
												asset={asset}
												imageRole="w=84,h=72"
												imageProportion="quarter"
												cardClass={'story-small'}
												qeId={qeId + '-bottom-' + i}
												showSummary={false}
												{...props}
											/>
										</TrackingProvider>
									))}
							</div>
						</div>
						<div
							class={cx(
								style.tirtiaryCards,
								width >= HERO_BREAKPOINT
									? style.allVertical
									: style.twoRowLayout
							)}
						>
							{bottomAssets.map((asset, i) => (
								<TrackingProvider
									{...{
										[DIMENSION.componentpath]: 'Bottom',
										[DIMENSION.clickindex]: i + 1
									}}
								>
									{width < HERO_BREAKPOINT && i >= 3 ? (
										<HorizontalCard
											theme={theme}
											asset={asset}
											imageRole="w=256,h=144"
											cardClass={cx(style.horizontalCard, 'small')}
											qeId={`${qeId}-bottom-${i}`}
											{...props}
										/>
									) : (
										<SimpleVerticalCard
											theme={theme}
											asset={asset}
											imageRole="w=256,h=144"
											cardClass={cx(style.qihCard, 'small')}
											qeId={`${qeId}-bottom-${i}`}
											{...props}
										/>
									)}
								</TrackingProvider>
							))}
						</div>
						<div class={style.tabFooter}>
							<CardHeader title={' '} link={link} qeId={qeId} theme={theme} />
							{linksfeed && (
								<LinksClusterP25
									clusterClass={style.linksCluster}
									title={linksfeed.title}
									feed={linksfeed.feed}
									qeId="sc-tab-links"
									{...getCommonProps(props)}
								/>
							)}
						</div>
					</div>
				</div>
			</TrackingProvider>
		);
	}
}
